angular.module('iSkanerAztecs', [
  'iSkanerLsn', 
  'ngSanitize',
  'iSkanerAztecs.base'
]);